import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    languageChange,
    currentSelectedLanguage,
  } from "../../../StateManagement/actions";
const Pagination = (props) => {
    const selectedLanguage = useSelector(currentSelectedLanguage);
    const { currentPage} = props;
    
    const totalPages = props.totalPages;
    // const data = props.response.data;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }
    const handlePrevClick = () => {
        props.onPrevClick();
    }
    const handleNextClick = () => {
        props.onNextClick();
    }
    const handlePageChange = (e) => {
        props.onPageChange(e);
    }
    const renderPaginationItems = () => {
        const paginationItems = [];
        const visiblePages = 5; // Change this value based on how many page numbers you want to show

        if (totalPages <= visiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                paginationItems.push(
                    <li className={currentPage === i ? 'active page-item' : 'page-item'}>
                        <a key={i} id={i} className='page-link'
                            onClick={() => handlePageChange(i)}
                            href='#'>{i}</a>
                    </li>
                );
            }
        } else {
            // Show dots if not on first pages
            if (currentPage > 3) {
                paginationItems.push(<li className={currentPage === 1 ? 'active page-item' : 'page-item'}>
                    <a className='page-link'
                        onClick={() => handlePageChange(1)}
                        href='#'>1</a>
                </li>);
                paginationItems.push(<li className="page-item not-allowed">
                    <span key="dots-end" className='page-link disabledLink'>...</span></li>);
            }

            let start = currentPage - Math.floor(visiblePages / 2);
            let end = currentPage + Math.floor(visiblePages / 2);

            if (start < 1) {
                end += Math.abs(start) + 1;
                start = 1;
            }

            if (end > totalPages) {
                start -= end - totalPages;
                end = totalPages;
            }
            for (let page = start; page <= end; page++) {
                if(start>=2 && page>start+1){
                paginationItems.push(
                    <li className={currentPage === page ? 'active page-item' : 'page-item'}>
                        <a key={page} id={page} className='page-link'
                            onClick={() => handlePageChange(page)}
                            href='#'>{page}</a>
                    </li>
                );
            }
            else if(start==1){
                paginationItems.push(
                    <li className={currentPage === page ? 'active page-item' : 'page-item'}>
                        <a key={page} id={page} className='page-link'
                            onClick={() => handlePageChange(page)}
                            href='#'>{page}</a>
                    </li>
                );
            }
            }
            // Show dots if not on last pages
            if (currentPage + 2 < totalPages) {
                paginationItems.push(
                    <li className="page-item not-allowed">
                        <span key="dots-end" className='page-link disabledLink'>...</span></li>
                );
                paginationItems.push(<li className='page-item'>
                    <a key="end" id="alink" className='page-link'
                        onClick={() => handlePageChange(totalPages)}
                        href='#'>{totalPages}</a>
                </li>
                )
            }
        }

        return paginationItems;
    };






    // const pageNumbers = pages.map(page => {
    //     if (page <= maxPageLimit && page > minPageLimit) {
    //         return (
    //             <li className={currentPage === page ? 'active page-item' : 'page-item'}>
    //                 <a key={page} id={page} className='page-link'
    //                     onClick={handlePageClick}
    //                     href='#'>{page}</a>
    //             </li>
    //         );
    //     } else {
    //         return null;
    //     }
    // })
    // let pageIncrementEllipses = null;
    // if (pages.length > maxPageLimit) {

    //     pageIncrementEllipses = <li className="page-item">
    //         <a className="page-link"
    //             onClick={handleNextClick}
    //             href='#'>
    //             &hellip;
    //         </a></li>


    // }
    // let pageDecremenEllipses = null;
    // if (minPageLimit >= 1) {       
    //     pageDecremenEllipses =
    //         <li className="page-item">
    //             <a className="page-link"
    //                 onClick={handlePrevClick}
    //                 href='#'>
    //                 &hellip;
    //             </a></li>
    // }
    // //const pageNumbers = [...Array(props.nPages + 1).keys()].slice(1);


    return (
        <nav className="navpage">
            <ul className='pagination justify-content-center'>
                <li className={(props.currentPage === 1) || props.DisablePrev == true ? "page-item not-allowed" : "page-item"}  >
                    <a className={(props.currentPage === 1) || props.DisablePrev == true ? "page-link disabledLink" : "page-link"}
                        onClick={handlePrevClick}
                        href='#'>

{selectedLanguage.LstLanguageCodes.UI_Previous}
                    </a>
                </li>
                {renderPaginationItems()}
                {/* {pageDecremenEllipses}
                {pageNumbers}
                {pageIncrementEllipses} */}
                <li className={(props.currentPage === props.totalPages) || props.DisableNext == true ? "page-item not-allowed" :"page-item"}>
                    <a id="anext" className={(props.currentPage === props.totalPages) || props.DisableNext == true ? "page-link disabledLink" : "page-link"}
                        onClick={handleNextClick}
                        href='#'>

{selectedLanguage.LstLanguageCodes.UI_Next}
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default Pagination